"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
require("./employee.scss");
var Employee = (function (_super) {
    __extends(Employee, _super);
    function Employee(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleView = _this.handleView.bind(_this);
        return _this;
    }
    Object.defineProperty(Employee.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var employee = this.props.employee;
            return (React.createElement("div", { className: employee.getEmployeeBoxClasses, onClick: this.handleView },
                React.createElement("div", null,
                    React.createElement("p", { className: "employee-display-name" }, employee.displayName),
                    React.createElement("p", { className: "employee-job-title" }, employee.jobTitleInternal)),
                React.createElement("div", { className: "action", hidden: employee.isIndividualContributor },
                    React.createElement("a", { onClick: this.handleClick, className: "view-employee" },
                        React.createElement("i", { className: "icon-users" }),
                        "\u00A0",
                        employee.directReportsCount,
                        "\u00A0",
                        React.createElement("i", { className: "icon-right-open" })))));
        }
    });
    Object.defineProperty(Employee.prototype, "handleClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            event.stopPropagation();
            var _a = this.props, onClick = _a.onClick, employee = _a.employee;
            onClick(employee);
        }
    });
    Object.defineProperty(Employee.prototype, "handleView", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, onView = _a.onView, employee = _a.employee;
            if (!employee.isViewable) {
                return;
            }
            onView(employee);
        }
    });
    return Employee;
}(React.Component));
exports.Employee = Employee;
exports.default = mobx_react_1.inject('store')(mobx_react_1.observer(Employee));
